import { render, staticRenderFns } from "./BannerVsa.vue?vue&type=template&id=671e1b2c&"
import script from "./BannerVsa.vue?vue&type=script&lang=js&"
export * from "./BannerVsa.vue?vue&type=script&lang=js&"
import style0 from "./BannerVsa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports